import { getAction } from '../../../shared/utils/getAction';
import { IOrganization } from '../../../shared/models/user/organization';
import { IParamsId } from '../../../shared/models/id';
import { IOrgReview } from '../../../shared/models/review';
import { IPaginationFilter } from '../../../shared/models/filter';
import { createAction, props } from '@ngrx/store';

export const organizationKey = 'Organization';

export const loadOrgProfile = getAction<IParamsId, IOrganization>(
  organizationKey,
  `Load Profile`
);
export const loadOrgMembers = getAction<
  IParamsId,
  { members: Object[]; count: number }
>(organizationKey, `Load Members`);
export const loadOrgClubs = getAction<IParamsId, object[]>(
  organizationKey,
  `Load Clubs`
);
export const loadOrgChapters = getAction<IParamsId, object[]>(
  organizationKey,
  `Load Chapters`
);
export const loadOrgJobs = getAction<IParamsId, object[]>(
  organizationKey,
  `Load Jobs`
);

export const loadOrgReview = getAction<IPaginationFilter, object[]>(
  organizationKey,
  `Load Review`
);
export const addOrgReview = getAction<IOrgReview, object>(
  organizationKey,
  `Add Review`
);

export const clearOrg = createAction('Clear Org Page');
